import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { useAddTemplateTextMutation, useUpdateTemplateTextMutation, useDeleteTemplateTextMutation } from '~/types/types';
import JsonEditorVue from 'json-editor-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateTextEdit',
  props: {
    questionId: {
      type: Number,
      required: true
    },
    templateTexts: {
      type: Array,
      required: true
    }
  },
  emits: ['template-text-added', 'template-text-updated', 'template-text-deleted', 'toggle-disable-save'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var activeTab = ref(0);
    var templateTextsExpanded = ref(false);

    // Delete dialog state
    var deleteDialog = ref({
      show: false,
      templateId: null
    });

    // Local reactive copy of template texts for immediate UI updates
    var localTemplateTexts = ref(_toConsumableArray(props.templateTexts));

    // Watch for prop changes to update local copy
    watch(function () {
      return props.templateTexts;
    }, function (newTemplateTexts) {
      localTemplateTexts.value = _toConsumableArray(newTemplateTexts);
    }, {
      deep: true
    });

    // Computed to return the current template texts (could be local or props)
    var templateTexts = computed(function () {
      return localTemplateTexts.value;
    });
    var _useAddTemplateTextMu = useAddTemplateTextMutation(),
      addTemplateText = _useAddTemplateTextMu.mutate;
    var _useUpdateTemplateTex = useUpdateTemplateTextMutation(),
      updateTemplateText = _useUpdateTemplateTex.mutate;
    var _useDeleteTemplateTex = useDeleteTemplateTextMutation(),
      deleteTemplateText = _useDeleteTemplateTex.mutate;
    var triggerAddTemplateText = function triggerAddTemplateText() {
      addTemplateText({
        input: {
          questionId: props.questionId,
          text: ''
        }
      }).then(function (result) {
        var _result$data;
        if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.addTemplateText) {
          // Add to local copy immediately
          localTemplateTexts.value.push(result.data.addTemplateText);
          // Emit to parent for potential refetch
          emit('template-text-added', result.data.addTemplateText);
        }
      });
    };
    var onTemplateInput = function onTemplateInput(id, text) {
      if (!text || text === ' ') {
        return;
      }

      // Update local copy immediately
      localTemplateTexts.value = localTemplateTexts.value.map(function (templateText) {
        if (templateText.id === id) {
          return _objectSpread(_objectSpread({}, templateText), {}, {
            text: text
          });
        }
        return templateText;
      });

      // Emit the change to parent
      emit('template-text-updated', {
        id: id,
        text: text
      });
    };
    var openDeleteDialog = function openDeleteDialog(templateId) {
      deleteDialog.value.templateId = templateId;
      deleteDialog.value.show = true;
    };
    var handleDeleteConfirm = function handleDeleteConfirm() {
      if (deleteDialog.value.templateId) {
        deleteTemplateText({
          id: deleteDialog.value.templateId
        }).then(function (result) {
          var _result$data2;
          if (result !== null && result !== void 0 && (_result$data2 = result.data) !== null && _result$data2 !== void 0 && _result$data2.deleteTemplateText) {
            localTemplateTexts.value = localTemplateTexts.value.filter(function (templateText) {
              return templateText.id !== deleteDialog.value.templateId;
            });
            emit('template-text-deleted', deleteDialog.value.templateId);
            if (activeTab.value >= localTemplateTexts.value.length) {
              activeTab.value = Math.max(0, localTemplateTexts.value.length - 1);
            }
          }
        });
      }
      deleteDialog.value.show = false;
      deleteDialog.value.templateId = null;
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      activeTab: activeTab,
      templateTextsExpanded: templateTextsExpanded,
      deleteDialog: deleteDialog,
      localTemplateTexts: localTemplateTexts,
      templateTexts: templateTexts,
      addTemplateText: addTemplateText,
      updateTemplateText: updateTemplateText,
      deleteTemplateText: deleteTemplateText,
      triggerAddTemplateText: triggerAddTemplateText,
      onTemplateInput: onTemplateInput,
      openDeleteDialog: openDeleteDialog,
      handleDeleteConfirm: handleDeleteConfirm,
      JsonEditorVue: JsonEditorVue
    };
  }
});